import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

export function useRemoveFamilyMember() {
  const queryClient = useQueryClient();

  const {
    mutateAsync,
    error,
    isPending: isLoading,
    reset,
  } = useMutation<unknown, Error, { familyId: string; clientId: string }>({
    mutationFn: ({ familyId, clientId }) => api.delete(`families/${familyId}/members/${clientId}`),
    onSuccess: (_data, { familyId }) => {
      queryClient.invalidateQueries({ queryKey: ['families'] });
      queryClient.invalidateQueries({ queryKey: ['families', familyId] });
      queryClient.invalidateQueries({ queryKey: ['clients'] });
    },
  });

  const removeFamilyMember = async (familyId: string, clientId: string) => {
    return mutateAsync({ familyId, clientId });
  };

  return {
    removeFamilyMember,
    error,
    isLoading,
    reset,
  };
}
